import Panel from "./Panel.js"

export default class AudioTracks extends Panel {

  constructor(props, context) {
    super(props, context)
    this.listOptions = []
    this.audioTracks = []
    this.activeIds = []
    this.state.title = "Audio" // TODO: Should be localized
    this.state.activeIndex = -1
  }

  static get contextTypes() {
    return super.contextTypes
  }

  componentWillMount() {
    super.componentWillMount()
    this.audioTracks = this.player.audioTracks
    this.oncanplaythrough({detail: this.audioTracks})
    this.open = true
  }

  clickHandler(object, index) {
    this.player.audioTracks[index].enabled = true
    this.setState({activeIndex: index-1})
    this.setState({redraw: true})
  }

  onmediachange(event) {
  	this.listOptions = []
  	this.activeIds = []
  }

  oncanplaythrough(event) {
  	this.audioTracks = this.player.audioTracks
    this.audioTracks.forEach((item) => {
      if (this.activeIds[item.id] == null) {
        const lang = this.player.localization.getLanguageString(item.language) || item.language
      	const label = item.label || lang || item.id || this.player.localization.getString("MSG_UNKNOWN")
        this.activeIds[item.id] = true
        this.listOptions.push({label})
      }
    })
    this.setState({redraw: true})
  }

  isOptionSelected(item, index) {
    return this.player.audioTracks[index].enabled
  }
}
